import { lazy } from "react";

import MainLayout from "../layout/MainLayout";
import Loadable from "../components/Loadable";
import ProtectedRoute from "./ProtectedRoute";

const CircuitBreaker = Loadable(
  lazy(() => import("../pages/admin/circuitBreaker/CircuitBreaker")),
);

const CircuitBreakerIoPort = Loadable(
  lazy(() => import("../pages/admin/circuitBreaker/IoPort_Write")),
);
const CircuitBreakerMbWr = Loadable(
  lazy(() => import("../pages/admin/circuitBreaker/MbWr_Write")),
);

// 보증 발전시간 탭
const GuaranteeTab = Loadable(
  lazy(() => import("../pages/admin/guaranteed/GuaranteeTab")),
);

// 보증발전시간
const GuaranteeHours = Loadable(
  lazy(() => import("../pages/admin/guaranteed/Guarantee")),
);

// 보증발전시간 그룹
const GuaranteeHoursGrp = Loadable(
  lazy(() => import("../pages/admin/guaranteed/GuaranteeGrp")),
);

// 보증발전시간 연차
const GuaranteePlant = Loadable(
  lazy(() => import("../pages/admin/guaranteed/GuaranteePlant")),
);

// 보증발전시간 연차 - 목록 보기
const GuaranteePlantDetail = Loadable(
  lazy(() => import("../pages/admin/guaranteed/GuaranteePlantDetail")),
);

// I-V Curve
const IVCurve = Loadable(lazy(() => import("../pages/admin/ivcurve/IVCurve")));

// Output Control
const OutputCtrl = Loadable(lazy(() => import("../pages/admin/OutputCtrl")));

// shunt  관리 페이지
const ShuntSch = Loadable(
  lazy(() => import("../pages/admin/shuntsch/ShuntSch")),
);

const ShuntSchCreate = Loadable(
  lazy(() => import("../pages/admin/shuntsch/ShuntSchCreate")),
);

const PATH = "admin";

const AdminRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: `${PATH}/circuit/ioport/create`,
      element: (
        <ProtectedRoute>
          <CircuitBreakerIoPort />
        </ProtectedRoute>
      ),
    },

    {
      path: `${PATH}/circuit/mbwr/create`,
      element: (
        <ProtectedRoute>
          <CircuitBreakerMbWr />
        </ProtectedRoute>
      ),
    },

    {
      path: `${PATH}/circuit/*`,
      element: (
        <ProtectedRoute>
          <CircuitBreaker />
        </ProtectedRoute>
      ),
    },

    {
      path: `${PATH}/guaranteehours`,
      element: (
        <ProtectedRoute>
          <GuaranteeHours />
        </ProtectedRoute>
      ),
    },

    {
      path: `${PATH}/guaranteehoursgrp`,
      element: (
        <ProtectedRoute>
          <GuaranteeHoursGrp />
        </ProtectedRoute>
      ),
    },

    {
      path: `${PATH}/ivcurve`,
      element: (
        <ProtectedRoute>
          <IVCurve />
        </ProtectedRoute>
      ),
    },

    {
      path: `${PATH}/guarantee`,
      element: (
        <ProtectedRoute>
          <GuaranteeTab />
        </ProtectedRoute>
      ),
    },

    {
      path: `${PATH}/guaranteeplants`,
      element: (
        <ProtectedRoute>
          <GuaranteePlant />
        </ProtectedRoute>
      ),
    },

    {
      path: `${PATH}/guaranteeplantdetail`,
      element: (
        <ProtectedRoute>
          <GuaranteePlantDetail />
        </ProtectedRoute>
      ),
    },

    {
      path: `${PATH}/outputctrl`,
      element: (
        <ProtectedRoute>
          <OutputCtrl />
        </ProtectedRoute>
      ),
    },

    // shunt  관리 페이지
    {
      path: `${PATH}/shuntschedule`,
      element: (
        <ProtectedRoute>
          <ShuntSch />
        </ProtectedRoute>
      ),
    },

    {
      path: `${PATH}/shuntschedule/create`,
      element: (
        <ProtectedRoute>
          <ShuntSchCreate />
        </ProtectedRoute>
      ),
    },

    {
      path: `${PATH}/shuntschedule/create/:id`,
      element: (
        <ProtectedRoute>
          <ShuntSchCreate />
        </ProtectedRoute>
      ),
    },
  ],
};

export default AdminRoutes;
